import {Component, Input, OnInit} from '@angular/core';
import {DocumentModel} from '../../models/document.model';
import {AlertController, ModalController} from '@ionic/angular';
import {PersistDocumentService} from '../../services/persist-document.service';
import {GeneralService} from '../../services/general.service';
import {StateManagerService} from '../../services/state-manager.service';
import {CollectionsNames} from '../../definitions/collections-names';
import {MobileConfigurationModel} from '../../models/mobile-configuration.model';
import {DocumentTypes} from '../../definitions/document-types';
import {ValidateDocumentService} from '../../services/validate-document.service';
import { HmheadDocTypes } from 'src/app/definitions/hmhead-doctypes';

@Component({
    selector: 'app-sign-document',
    templateUrl: './sign-document.page.html',
    styleUrls: ['./sign-document.page.scss'],
})

export class SignDocumentPage implements OnInit {

    @Input() document: DocumentModel;
    @Input() counterSigningMode: boolean;
    documentTemp: DocumentModel;
    title: string;
    mobileConfiguration: MobileConfigurationModel;

    constructor(private modalController: ModalController,
                private alertController: AlertController,
                private persistDocService: PersistDocumentService,
                private generalServices: GeneralService,
                private stateManager: StateManagerService,
                private collectionNames: CollectionsNames,
                private docTypes: DocumentTypes,
                private validateDoc: ValidateDocumentService,
                private hmheadDoctypes: HmheadDocTypes ) {
    }

    ngOnInit() {
    }

    ionViewDidEnter() {
        this.documentTemp = JSON.parse(JSON.stringify(this.document));
        this.mobileConfiguration = this.stateManager.getCollection(this.collectionNames.MOBILECONFIGURATION);
        this.setTitle();
        if (!this.documentTemp.scheduledDate) {
            this.documentTemp.scheduledDate = this.documentTemp.creationDate;
        }
    }

    saveSignedDocument() {
        if (!this.validateDoc.isValid(this.documentTemp)) {
            return;
        }
        if (this.mobileConfiguration
            && ( ( this.mobileConfiguration.mobilehirePictureRequiredForDelivery === 1 && this.documentTemp.originalDocumentType === this.hmheadDoctypes.CONTRACT ) ||
             ( this.mobileConfiguration.mobilehirePictureRequiredForCollection === 1 && this.documentTemp.originalDocumentType === this.hmheadDoctypes.OFFHIRE ) )
            && this.documentTemp.documentType === this.docTypes.SIGNDOCUMENT
            && (!this.documentTemp.photosURL || this.documentTemp.photosURL.length <= 0)) {
            alert('No photos recorded, please take pictures of the ' + this.title);
            return;
        }
        delete this.documentTemp.icon;
        this.document = JSON.parse(JSON.stringify(this.documentTemp));
        this.persistDocService.persistDocument(this.document);
        this.modalController.dismiss(this.document);
        this.generalServices.createToast(this.title + ' Saved!');
    }

    cancelSignedDocument() {
        if (this.documentTemp !== this.document) {
            this.confirmCancel();
        } else {
            this.modalController.dismiss();
        }
    }

    async confirmCancel() {
        if (this.counterSigningMode) {
            this.modalController.dismiss();
        } else {
            const alert = await this.alertController.create({
                message: 'Do you want to cancel the ' + this.title + '?',
                backdropDismiss: false,
                buttons: [
                    {
                        text: 'No',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                        }
                    }, {
                        text: 'Yes',
                        handler: () => {
                            this.modalController.dismiss();
                        }
                    }
                ]
            });
            await alert.present();
        }
    }

    setTitle() {
        if (this.documentTemp.originalDocumentType === this.hmheadDoctypes.CONTRACT ) {
            this.title = 'Delivery';
        } else if (this.documentTemp.originalDocumentType === this.hmheadDoctypes.OFFHIRE ) {
            this.title = 'Collection';
        } else if (this.documentTemp.originalDocumentType === this.hmheadDoctypes.RETURN ) {
            this.title = 'Return';
        } else {
            this.title = 'Sign Document';
        }
    }
}
